import React, { useEffect } from "react";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import TopActionMenus from "./TopActionMenus";
import { useVisitorDetails } from "./VisitorDetailsContext";
import { useNavigationEvent } from "navigation-react";

const VisitorSignRegisterDetails = () => {
  const { selectedVisitor } = useVisitorDetails();
  const { stateNavigator } = useNavigationEvent();

  // Base URL for images from environment
  const baseURL = process.env.REACT_APP_DRUPAL_BASE_URL;

  // Redirect back if no visitor selected
  useEffect(() => {
    if (!selectedVisitor) {
      stateNavigator.navigate("visitorsignregister");
    }
  }, [selectedVisitor, stateNavigator]);

  if (!selectedVisitor) {
    return null;
  }

  // Full visitor image URL
  const visitorImage = selectedVisitor?.field_visit_picture
    ? `${baseURL}${selectedVisitor.field_visit_picture}`
    : null;

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />

        <div className="patient-register">
          <TopActionMenus
            AddTitle="Visitor Details"
            backIcon={faArrowLeft}
            backNavigationLink="visitorsignregister"
          />

          <div className="visitor-details">
            <div className="visitorPicture">
              {visitorImage ? (
                <img src={visitorImage} alt="Visitor" />
              ) : (
                <div
                  style={{
                    width: "120px",
                    height: "120px",
                    borderRadius: "50%",
                    background: "#eee",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#777",
                  }}
                >
                  No Image
                </div>
              )}
              <h2>
                {`${selectedVisitor?.field_title_prefix || ""} ${
                  selectedVisitor?.field_full_name || ""
                }`.trim()}
              </h2>
            </div>

            {/* Visitor Info Group 1 */}
            <div className="detail-item-wrapper">
              <div className="detail-item">
                <strong>Company:</strong>
                <span>{selectedVisitor?.field_company || "-"}</span>
              </div>
              <div className="detail-item">
                <strong>Contact Number:</strong>
                <span>{selectedVisitor?.field_contact_number || "-"}</span>
              </div>
              <div className="detail-item">
                <strong>Nationality:</strong>
                <span>{selectedVisitor?.field_nationality || "-"}</span>
              </div>
              <div className="detail-item">
                <strong>Location:</strong>
                <span>{selectedVisitor?.field_visitor_location || "-"}</span>
              </div>
              <div className="detail-item">
                <strong>Who to Visit:</strong>
                <span>
                  {`${selectedVisitor?.field_firist_name || ""} ${
                    selectedVisitor?.field_last_name || ""
                  }`.trim() || "-"}
                </span>
              </div>
            </div>

            {/* Visitor Info Group 2 */}
            <div className="detail-item-wrapper">
              <div className="detail-item">
                <strong>Purpose:</strong>
                <span>{selectedVisitor?.field_purpose_of_visit || "-"}</span>
              </div>
              <div className="detail-item">
                <strong>Visitor Pin:</strong>
                <span>{selectedVisitor?.field_visitor_pin || "-"}</span>
              </div>
              <div className="detail-item">
                <strong>Status:</strong>
                <span>{selectedVisitor?.field_status || "-"}</span>
              </div>
              <div className="detail-item">
                <strong>Sign In Time:</strong>
                <span>{selectedVisitor?.field_sign_in_time || "-"}</span>
              </div>
              <div className="detail-item">
                <strong>Sign Out Time:</strong>
                <span>
                  {selectedVisitor?.field_sign_out_time || "Yet to Sign Out"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DashboardContentFooter />
    </div>
  );
};

export default VisitorSignRegisterDetails;
